import React from "react";
import { Navigate } from "react-router-dom";

const AuthProtected = (props) => {
  // Check if user is authenticated by verifying token in sessionStorage
  const authUser = sessionStorage.getItem("authUser");

  if (!authUser) {
    return <Navigate to="/login" replace />;
  }

  try {
    const { token } = JSON.parse(authUser);
    if (!token) {
      return <Navigate to="/login" replace />;
    }
  } catch (error) {
    console.error("Error parsing auth user:", error);
    sessionStorage.removeItem("authUser");
    return <Navigate to="/login" replace />;
  }

  return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return <Component {...rest} />;
};

export { AuthProtected, AccessRoute };